export const useSchoolCourses = () => {
  // Cursos baseados no supabase - ordem conforme a tabela
  const courses = [
    { key: "instruments" },
    { key: "djing" },
    { key: "musicProduction" },
  ];

  const courseIcons = ["🎸", "🎛️", "🎚️"];

  return {
    courses,
    courseIcons,
  };
};
